import React from 'react';
import { observer } from 'owa-mobx-react';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { TeachingBubble } from '@fluentui/react/lib/TeachingBubble';
import type { IButtonProps } from '@fluentui/react/lib/Button';
import { teachingBubble, primaryButton } from './TeachingMoment.scss';

import loc from 'owa-localize';
import { bookwithmeCloseButtonAriaLabelForTeachingMoment } from './Shared.locstring.json';
import type { ResourceId } from 'owa-localize';

interface TeachingMomentProps {
    onButtonClick: () => void;
    onDismiss: () => void;
    teachingHeader: ResourceId;
    teachingSummary: ResourceId;
    teachingButtonLabel: ResourceId;
    target: React.RefObject<HTMLDivElement>;
    isOpen: boolean;
}

const callOutProps = {
    beakWidth: 16,
    preventDismissOnScroll: true,
    preventDismissOnLostFocus: true,
    directionalHint: DirectionalHint.bottomLeftEdge,
    className: teachingBubble,
};

const styleProps = {
    subComponentStyles: {
        callout: {
            root: { borderRadius: 16 },
            beakCurtain: { borderRadius: 16 },
            calloutMain: { borderRadius: 16 },
        },
    },
    footer: {
        ['& > .ms-StackItem']: {
            display: 'flex',
            flexDirection: 'row-reverse',
        },
    },
};

export default observer(function TeachingMoment(props: TeachingMomentProps) {
    const {
        onButtonClick,
        onDismiss,
        teachingHeader,
        teachingSummary,
        teachingButtonLabel,
        target,
        isOpen,
    } = props;

    const primaryButtonProps: IButtonProps = React.useMemo(
        () => ({
            text: loc(teachingButtonLabel),
            onClick: onButtonClick,
            className: primaryButton,
        }),
        []
    );

    return (
        <>
            {isOpen && (
                <TeachingBubble
                    calloutProps={callOutProps}
                    styles={styleProps}
                    hasCloseIcon={true}
                    onDismiss={onDismiss}
                    primaryButtonProps={primaryButtonProps}
                    headline={loc(teachingHeader)}
                    target={target}
                    closeButtonAriaLabel={loc(bookwithmeCloseButtonAriaLabelForTeachingMoment)}
                >
                    {loc(teachingSummary)}
                </TeachingBubble>
            )}
        </>
    );
}, 'TeachingMoment');
